module.exports = __webpack_public_path__ + "img/2.0a9cae91.png";